import { ACADEMYDATA, AcademyData } from 'store/actions/currentAcademyID';

const initialState: AcademyData = {
  AcademyId: '',
  Role: '',
  userId: '',
  academyName: ''
};

export const currentAcademyIDReducer = (
  state = initialState,
  action: any
): AcademyData => {
  switch (action.type) {
    case ACADEMYDATA:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
